import { render, staticRenderFns } from "./ShareTrackButton.vue?vue&type=template&id=284a8d84&"
import script from "./ShareTrackButton.vue?vue&type=script&lang=js&"
export * from "./ShareTrackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports